import React, { useState, useEffect } from "react";
import Logo from "./../../assets/logo.png";
import {
  IoShareSocialOutline,
  IoSearch,
  IoHeartOutline,
  IoMenu,
  IoClose,
} from "react-icons/io5";
import { AiOutlineUser } from "react-icons/ai";
import { HiOutlineShoppingBag } from "react-icons/hi";
import { IoIosArrowDown } from "react-icons/io";
import {
  FaFacebookF,
  FaGooglePlusG,
  FaInstagram,
  FaTelegramPlane,
  FaTwitter,
} from "react-icons/fa";
import { Link } from "react-router-dom"; // Import Link

const Navbar = () => {
  const [isHomepageDropdownOpen, setHomepageDropdownOpen] = useState(false);
  const [isShopDropdownOpen, setShopDropdownOpen] = useState(false);
  const [isSocialDropdownOpen, setSocialDropdownOpen] = useState(false);
  const [isSearchDropdownOpen, setIsSearchDropdownOpen] = useState(false);
  const [isSticky, setSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={`bg-[#00080f] p-2 md:p-6 ${isSticky ? "sticky top-0 z-50" : ""}`}>
      <div className="flex items-center justify-between">
        <div className="block md:hidden text-white text-4xl">
          <IoMenu />
        </div>
        <div className="flex items-center gap-8">
          <div>
            <img src={Logo} alt="" className="w-full min-w-[150px]" />
          </div>
          <ul className="text-white hidden gap-4 lg:gap-7 md:flex">
            <li
              className="text-primary font-rubik font-bold cursor-pointer flex items-center lg:gap-2 max-lg:text-sm relative"
              onMouseEnter={() => setHomepageDropdownOpen(true)}
              onMouseLeave={() => setHomepageDropdownOpen(false)}
            >
              <Link to="/">Homepage</Link>
              <IoIosArrowDown
                size={18}
                className={`transition-transform duration-300 ${
                  isHomepageDropdownOpen ? "rotate-180" : ""
                }`}
              />
              {isHomepageDropdownOpen && (
                <ul className="absolute top-full left-0 font-normal bg-[#fff] min-w-[200px] text-black p-5 space-y-5 rounded shadow-lg z-10">
                  <li className="hover:text-primary cursor-pointer">
                    <Link to="/homepage1">Homepage 1</Link>
                  </li>
                  <li className="hover:text-primary cursor-pointer">
                    <Link to="/homepage2">Homepage 2</Link>
                  </li>
                </ul>
              )}
            </li>
            <li
              className="text-white font-rubik font-bold hover:text-primary cursor-pointer flex items-center lg:gap-2 max-lg:text-sm relative z-10"
              onMouseEnter={() => setShopDropdownOpen(true)}
              onMouseLeave={() => setShopDropdownOpen(false)}
            >
              <Link to="/shop">Shop</Link>
              <IoIosArrowDown
                size={18}
                className={`transition-transform duration-300 ${
                  isShopDropdownOpen ? "rotate-180" : ""
                }`}
              />
              {isShopDropdownOpen && (
                <ul className="absolute top-full left-0 font-normal bg-[#fff] min-w-[200px] text-black p-5 space-y-5 rounded shadow-lg  z-10">
                  <li className="hover:text-primary cursor-pointer">
                    <Link to="/shop/xbox">Xbox</Link>
                  </li>
                  <li className="hover:text-primary cursor-pointer">
                    <Link to="/shop/games">Games</Link>
                  </li>
                  <li className="hover:text-primary cursor-pointer">
                    <Link to="/shop/playstation">Playstation</Link>
                  </li>
                  <li className="hover:text-primary cursor-pointer">
                    <Link to="/shop/pc">PC</Link>
                  </li>
                </ul>
              )}
            </li>
            <li className="text-white font-rubik font-bold hover:text-primary cursor-pointer max-lg:text-sm">
              <Link to="/news">News</Link>
            </li>
            <li className="text-white font-rubik font-bold hover:text-primary cursor-pointer max-lg:text-sm">
              <Link to="/games">Games</Link>
            </li>
            <li className="text-white font-rubik font-bold hover:text-primary cursor-pointer max-lg:text-sm">
              <Link to="/xbox">Xbox</Link>
            </li>
            <li className="text-white font-rubik font-bold hover:text-primary cursor-pointer max-lg:text-sm">
              <Link to="/playstation">Playstation</Link>
            </li>
            <li className="text-white font-rubik font-bold hover:text-primary cursor-pointer max-lg:text-sm">
              <Link to="/pc">PC</Link>
            </li>
          </ul>
        </div>
        <ul className="text-white flex gap-2 lg:gap-6">
          <li className="relative hover:text-primary cursor-pointer text-2xl lg:text-[35px] font-bold hidden md:block">
            {isSearchDropdownOpen ? (
              <IoClose onClick={() => setIsSearchDropdownOpen(false)} />
            ) : (
              <IoSearch onClick={() => setIsSearchDropdownOpen(true)} />
            )}
            {isSearchDropdownOpen && (
              <div className="absolute top-full right-0 font-normal bg-[#fff] min-w-[600px] p-2 text-black rounded shadow-lg flex items-center justify-center gap-5 py-5  z-10">
                <div className="flex border-2 border-[#f2f6f9] rounded-full w-full pl-4">
                  <select className="text-base font-rubik font-medium text-gray-400 outline-none">
                    <option>All Categories</option>
                    <option>All Categories</option>
                    <option>All Categories</option>
                    <option>All Categories</option>
                  </select>
                  <input
                    type="text"
                    className="outline-none text-base font-rubik font-medium flex-1"
                  />
                  <button className="text-base font-rubik font-medium bg-primary h-14 rounded-r-full px-4 text-white">
                    Search
                  </button>
                </div>
              </div>
            )}
          </li>
          <li
            className="relative hover:text-primary cursor-pointer text-2xl lg:text-[35px] font-bold hidden md:block"
            onMouseEnter={() => setSocialDropdownOpen(true)}
            onMouseLeave={() => setSocialDropdownOpen(false)}
          >
            <IoShareSocialOutline />
            {isSocialDropdownOpen && (
              <ul className="absolute top-full right-0 font-normal bg-[#fff] min-w-[400px] text-black p-2 rounded shadow-lg flex items-center justify-center gap-5 py-5  z-10">
                <li className="bg-[#395498] hover:bg-primary text-white cursor-pointer w-10 h-10 flex justify-center items-center rounded-full text-xl">
                  <FaFacebookF />
                </li>
                <li className="bg-[#5da9dd] hover:bg-primary text-white cursor-pointer w-10 h-10 flex justify-center items-center rounded-full text-xl">
                  <FaTwitter />
                </li>
                <li className="bg-[#d54c40] hover:bg-primary text-white cursor-pointer w-10 h-10 flex justify-center items-center rounded-full text-xl">
                  <FaGooglePlusG />
                </li>
                <li className="bg-[#29a1d5] hover:bg-primary text-white cursor-pointer w-10 h-10 flex justify-center items-center rounded-full text-xl">
                  <FaTelegramPlane />
                </li>
                <li className="bg-[#00afc0] hover:bg-primary text-white cursor-pointer w-10 h-10 flex justify-center items-center rounded-full text-xl">
                  <FaInstagram />
                </li>
              </ul>
            )}
          </li>
          <li className="hover:text-primary cursor-pointer text-2xl lg:text-[35px] font-bold hidden md:block">
            <AiOutlineUser />
          </li>
          <li className="relative hover:text-primary cursor-pointer text-2xl lg:text-[35px] font-bold hidden md:block">
            <IoHeartOutline />
            <span className="absolute -top-1 -left-1 bg-primary text-white text-xs rounded-full h-4 w-4 flex items-center justify-center">
              0
            </span>
          </li>
          <li className="relative hover:text-primary cursor-pointer text-2xl lg:text-[35px] font-bold">
            <HiOutlineShoppingBag />
            <span className="absolute -top-1 -left-1 bg-primary text-white text-xs rounded-full h-4 w-4 flex items-center justify-center">
              3
            </span>
          </li>
        </ul>
      </div>
      <div className="flex border-2 border-[#f2f6f9] rounded-full w-full mt-4 md:hidden">
        <input
          type="text"
          className="outline-none text-base font-rubik font-medium flex-1 rounded-l-full pl-4"
          placeholder="Search"
        />
        <button className="text-3xl min-w-[40px] font-rubik font-medium bg-primary h-12 rounded-r-full px-4 text-white flex justify-center items-center">
          <IoSearch />
        </button>
      </div>
    </div>
  );
};

export default Navbar;
